import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LastActiveTabState {
  id: string | null;
  direction: string | null;
}

const initialState: LastActiveTabState = {
  id: null,
  direction: "left",
};

export const lastActiveTabSlice = createSlice({
  name: "lastActiveTab",
  initialState,
  reducers: {
    setLastActiveTab: (state, action) => {
      state.id = action.payload.id;
      state.direction = action.payload.direction;
    },
  },
});

export const { setLastActiveTab } = lastActiveTabSlice.actions;

export const selectLastActiveTab = (state: {
  lastActiveTab: LastActiveTabState;
}) => state.lastActiveTab;

export const lastActiveTab = lastActiveTabSlice.reducer;
